import type { IViewFile, IViewSet, IViewSettings, StandardViewKey, ViewKey } from '@platform/core/types';
import { narrowInsightSettings } from './narrowInsightSettings';

/** Налаштування подання з файлу: без службових kind/default; параметри аналітики звужені до типів рушія (narrowInsightSettings). */
function settingsOf({ kind: _kind, default: _default, insight, ...rest }: IViewFile): IViewSettings {
  return insight ? { ...rest, insight: narrowInsightSettings(insight) } : rest;
}

/**
 * Збирає набір подань типу запису з файлів пакета (pages/<сутність>/views/<ключ>.json): увімкнені — стандартні види у порядку файлів,
 * власні — kind 'custom', типове — позначене default (інакше перше), колонки таблиці та групування дошки — з відповідних файлів,
 * налаштування кожного подання — з його файлу (insight звужується: невідомі kind, mode і тони відкидаються).
 */
export function assembleViewSet(files: Record<string, IViewFile>): IViewSet {
  const entries = Object.entries(files);
  const standard = entries.filter(([, v]) => v.kind !== 'custom').map(([key]) => key as StandardViewKey);
  const custom = entries.filter(([, v]) => v.kind === 'custom').map(([key]) => key);
  const defaultKey = (entries.find(([, v]) => v.default)?.[0] ?? standard[0] ?? custom[0] ?? 'table') as ViewKey;
  const settings = Object.fromEntries(entries.map(([key, file]) => [key, settingsOf(file)]));
  return {
    enabled: standard,
    default: defaultKey,
    columns: files['table']?.columns ?? null,
    boardGroupBy: files['backlog']?.groupBy,
    custom,
    settings,
  };
}
